import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Webcam } from '../../assets/images/svg/webcam.svg';
import themeColors from '../../assets/styles/themeColors';

const WebcamIconStyled = styled(Webcam)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  color: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const WebcamIcon = (props) => <WebcamIconStyled {...props} />;

WebcamIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

WebcamIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default WebcamIcon;
